import { Injectable } from '@angular/core';
import { BaseBackend } from '@shared/apis/servers/base-backend';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BpBackendServer extends BaseBackend {

  getBp(search?): Observable<any> {
    return this.get('/bp', { params: { search } });
  }

  getBpDetail(bpNo): Observable<any> {
    return this.get(`/bp/${ bpNo }`);
  }

  saveCustomer(customer): Observable<any> {
    const { bpNo } = customer;
    if (bpNo) {
      return this.patch(`/bp/${ bpNo }`, customer);
    }
    return this.post('/bp', customer);
  }
}
